<template>
  <div class="dict">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <!-- 基本信息 -->
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"><span></span>基本信息</div>
        </template>
        <div class="collapse-content">
          <BaseInfo :canEdit="canEdit" :currencyList="currencyList" ref="baseInfo" />
        </div>
      </el-collapse-item>
      <!-- 行信息 -->
      <el-collapse-item name="4">
        <el-tabs type="border-card" v-model="activeNameTab" class="addCooperationTabs">
          <!-- 设备抵押行信息 -->
          <el-tab-pane name="first" :label="'设备抵押行信息'">
            <RowInfo :canEdit="canEdit" :validateInbound="validateInbound" ref="rowInfo" />
          </el-tab-pane>
        </el-tabs>
      </el-collapse-item>
      <el-collapse-item name="5">
        <template slot="title">
          <div class="collapse-title-pre"><span></span>上传附件</div>
        </template>
        <div class="collapse-content">
          <upload
            ref="upload"
            :isShow="canEdit && ['', 'saved', 'rejected'].indexOf(baseInfo.mortgageStatus) != -1"
            defaultPath="scm/equipmentMortgage"
            :data="{ ...tokenInfo }"
            :tableData="attachmentList"
            @upload="uploadList"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!-- 编辑 -->
      <!-- ||
          !baseInfo.mortgageStatus -->
      <el-button
        :disabled="
          (['saved', 'rejected'].indexOf(baseInfo.mortgageStatus) == -1 && !canEdit) ||
          !baseInfo.mortgageStatus
        "
        type="primary"
        @click="edit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('mcInboundEdit.btns.edit') }}
      </el-button>

      <!-- 保存 -->
      <el-button
        :disabled="
          ['', 'saved', 'rejected'].indexOf(this.baseInfo.mortgageStatus) == -1 || !canEdit
        "
        type="primary"
        @click="save"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('mcInboundEdit.btns.save') }}
      </el-button>
      <!-- 提交 -->
      <el-button
        :disabled="['', 'saved', 'rejected'].indexOf(this.baseInfo.mortgageStatus) == -1"
        type="primary"
        @click="submit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('mcInboundEdit.btns.submission') }}
      </el-button>
      <!-- 删除 -->
      <el-button
        :disabled="['saved', 'rejected'].indexOf(this.baseInfo.mortgageStatus) == -1"
        type="primary"
        @click="deleteRecord"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('mcInboundEdit.btns.delete') }}
      </el-button>
    </div>
    <print-dialog
      ref="printDialog"
      :id="String($route.query.id)"
      :deleveryFlag="this.deleveryFlag"
    ></print-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import BaseInfo from './components/baseInfo';
  import RowInfo from './components/rowInfo';
  import API from '@/api/purchaseSalesCenter/credit/equipmentMortgage.js';
  // import { delcommafy } from '@/common/js/util';
  // import BASE_API from '@/api/dataBase';
  import loading from '@/common/js/load.js'; //loading
  import voucherMixins from '@/common/mixins/voucher.js';
  import Upload from '@/components/upload';
  import printDialog from './components/printDialog';

  export default {
    mixins: [voucherMixins],
    components: {
      BaseInfo,
      RowInfo,
      Upload,
      printDialog,
    },
    name: 'baseEdit',
    data() {
      return {
        state: '',
        activeNameTab: 'first',
        voucherList: [], //凭证列表
        load: false,
        activeNames: ['1', '2', '3', '4', '5', '6'], //默认展开那些面板，
        editConfigFlag: false,
        type: false,
        canEdit: this.$route.query.isEdit == 'Y',
        companyTree: [], // 部门数
        menuButtonList: [],
        payList: [], //付款信息
        defaultVisible: false, //匹配采购合同
        attachmentList: [],
        checkRowKeys: [],
        baseInfo: {
          mortgageStatus: '',
        }, //基本信息
        // 币种
        currencyList: [],
        dictList: {
          reverseFlagOptions: [],
          unitOptions: [],
          mortgageStatus: [],
        }, //字典
        deleveryFlag: false,
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
        stateDictList(state) {
          this.state = state;
          if (state.dict.dictList.length > 10) {
            this.dictList.reverseFlagOptions = state.dict.dictList.find(
              (it) => it.dictType == 'reverseFlag'
            ).dictList;
            this.dictList.unitOptions = state.dict.dictList.find(
              (it) => it.dictType == 'basic_unit'
            ).dictList;
            this.dictList.mortgageStatus = state.dict.dictList.find(
              (it) => it.dictType == 'mortgage_status'
            ).dictList;
            this.$forceUpdate();
          }
        },
      }),
    },
    watch: {
      stateDictList(newV) {
        if (newV.length > 10) {
          this.dictList.reverseFlagOptions = newV.find(
            (it) => it.dictType == 'reverseFlag'
          ).dictList;
          this.$forceUpdate();
        }
      },
    },
    mounted() {
      // this.getCurrencyList()
      //制单人默认
      // const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd')
      this.baseInfo.businessCompanyName = this.userInfo.companyName;
      this.baseInfo.businessCompanyCode = this.userInfo.companyCode;
      this.baseInfo.businessDepartmentName = this.userInfo.departmentName;
      this.baseInfo.businessDepartmentCode = this.userInfo.departmentCode;
      this.baseInfo.businessPersonNo = this.userInfo.userCode;
      this.baseInfo.businessPersonName = this.userInfo.userName;

      // this.baseInfo.inboundCreateDate = date //制单日期
      // 基本信息默认值
      this.$refs.baseInfo.formData = Object.assign(this.$refs.baseInfo.formData, this.baseInfo);
      console.log(this.$refs.baseInfo.formData);
      const query = this.$route.query;
      // this.baseInfo.id = query['id']
      if (query) {
        this.getDetail();
      } else {
        // 新增情况下需监听字段变化
        this.$refs.baseInfo.initFlag = false;
      }
    },
    methods: {
      //获取字典值
      getDict() {
        let tenantCode = this.userInfo.userInfo.tenantCode;
        console.log(tenantCode);
        //合作伙伴类型
        // this.$axios
        //   .post(DataBaseAPI.DIC_CREDIT_API, {
        //     dictType: 'partner_type',
        //     tenantCode,
        //   })
        //   .then((res) => {
        //     if (0 == res.data.code) {
        //       this.partnerTypeList = res.data.data;
        //       console.log(this.partnerTypeList);
        //       for (var item of res.data.data) {
        //         this.enterprisePropertyData[item['value']] = item['label'];
        //       }
        //     }
        //   });
        //授信类型
        // this.$axios
        //   .post(DataBaseAPI.DIC_CREDIT_API, {
        //     dictType: 'credit_type',
        //     tenantCode,
        //   })
        //   .then((res) => {
        //     if (0 == res.data.code) {
        //       this.creditTypeList = res.data.data;
        //       for (var item of res.data.data) {
        //         this.creditTypeData[item['value']] = item['label'];
        //       }
        //     }
        //   });
        //设备种类
        // this.$axios
        //   .post(DataBaseAPI.DIC_CREDIT_API, {
        //     dictType: "credit_type",
        //     tenantCode,
        //   })
        //   .then((res) => {
        //     if (0 == res.data.code) {
        //       this.creditTypeList = res.data.data;
        //       for (var item of res.data.data) {
        //         this.creditTypeData[item["value"]] = item["label"];
        //       }
        //     }
        //   });
      },

      // 获取设备抵押申请单详情
      getDetail() {
        // let url = '';
        const query = this.$route.query;
        // const name = this.$route.name;
        // const userBaseInfo = this.userBaseInfo;
        // console.log(query);
        if (query.id) {
          console.log(query.id);
          // const url = API.DETAIL_EQUIPMENT_MORTGAGE_API;
          this.$axios.get(`${API.DETAIL_EQUIPMENT_MORTGAGE_API}/${query.id}`).then((res) => {
            if (res.data.code == 0) {
              console.log(res.data);
              const data = res.data.data;
              this.baseInfo = Object.assign({}, data);
              this.attachmentList = this.baseInfo.attachmentVOList || [];
              console.log(this.baseInfo);
              this.$refs.baseInfo.getDetail(this.baseInfo);
              this.$refs.rowInfo.tableData = data.detailList;
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      // 校验基本信息
      validateInbound() {
        return new Promise((resolve, reject) => {
          this.$refs.baseInfo
            .getVal()
            .then(() => {
              console.log('validateInboundSuc');
              resolve(true);
            })
            .catch(() => {
              console.log('validateInbounderr');
              reject();
            });
        });
        // if (!flag) return;
        /* return new Promise((resolve, reject) => {
        this.$refs.baseInfo.$refs.topData.$refs['ruleForm'].validate(validate=>{
          validate?resolve(true):resolve(false)
        })
      }) */
      },
      refreshData() {},

      handleClick(item) {
        console.log(item);
        switch (item.buttonUrl) {
          case 'save':
            this.save();
            break;
        }
      },

      //更新附件列表
      uploadList(value) {
        this.attachmentList = [];
        console.log(this.tokenInfo);
        if (value.length) {
          value.map((item) => {
            this.attachmentList.push({
              ...item,
              ...this.tokenInfo,
            });
          });
        }
      },
      // // 提交
      submit() {
        const p1 = this.validateInbound();
        const p2 = new Promise((resolve, reject) => {
          this.$refs['rowInfo'].$refs['ruleTable'].validate((valid) => {
            valid ? resolve() : reject();
          });
        });
        // let url = this.baseInfo.id ? API.UPDATE_SUBMIT : API.SAVE_SUBMIT;
        let url = API.SUBMIT_EQUIPMENT_MORTGAGE_API;
        console.log(url);
        let detailList = this.$refs.rowInfo.exportTableData(); //设备明细
        Promise.all([p1, p2]).then(() => {
          let params = {
            ...this.$refs.baseInfo.formData,
            detailList,
            attachmentDTOList: this.attachmentList,
            id: this.baseInfo.id || null,
            lastModifiedBy: this.userInfo.userCode,
            submitFlag: 1,
          };
          params = this.$baseRequest.assignObj(params);
          console.log(params);
          loading.startLoading();
          this.$axios
            .post(url, params)
            .then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                this.goBack();
                this.$message({
                  showClose: true,
                  message: this.$t('message.success'),
                  type: 'success',
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            })
            .catch(() => loading.endLoading());
        });
      },
      // 保存
      save() {
        const p1 = this.validateInbound();
        const p2 = new Promise((resolve, reject) => {
          this.$refs['rowInfo'].$refs['ruleTable'].validate((valid) => {
            valid ? resolve() : reject();
          });
        });
        // let url = this.baseInfo.id ? API.UPDATE_SUBMIT : API.SAVE_SUBMIT;
        let url = API.ADD_EQUIPMENT_MORTGAGE_API;
        console.log(url);
        let detailList = this.$refs.rowInfo.exportTableData(); //设备明细
        Promise.all([p1, p2]).then(() => {
          let params = {
            ...this.$refs.baseInfo.formData,
            detailList,
            attachmentDTOList: this.attachmentList,
            id: this.baseInfo.id || null,
            lastModifiedBy: this.userInfo.userCode,
            saveUpdate: 1,
            submitFlag: 0,
          };
          // if(params.invoiceType=="creditMemo" && params.invoiceAmount>=0){
          //   this.$message({
          //     showClose: true,
          //     message: this.$t("mcInboundEdit.warnInfo.needLowZero"),
          //     type: "error"
          //   });
          //   return;
          // }else if(params.invoiceType=="invoice" && params.invoiceAmount<=0){
          //   this.$message({
          //     showClose: true,
          //     message: this.$t("mcInboundEdit.warnInfo.needOverZero"),
          //     type: "error"
          //   });
          //   return;
          // }
          // params.mcInboundEditDetailLsit.map((item,index)=>{
          //   item["invoiceDetailCode"] = index+1
          //   item = this.$baseRequest.assignObj(item)
          //   return item;
          // })
          params = this.$baseRequest.assignObj(params);
          loading.startLoading();
          this.$axios
            .post(url, params)
            .then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'success',
                });
                const data = res.data.data;
                this.baseInfo = Object.assign({}, data);
                this.$refs.baseInfo.getDetail(this.baseInfo);
                this.$refs.rowInfo.tableData = data.detailList;
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            })
            .catch(() => loading.endLoading());
        });
      },

      // 编辑
      edit() {
        this.canEdit = true;
      },
      // 删除
      deleteRecord() {
        this.$confirmAction()
          .then(() => {
            loading.startLoading();
            let ids = [];
            ids.push(this.baseInfo.id);
            this.$axios.post(API.DELETE_EQUIPMENT_MORTGAGE_API, { ids }).then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                this.goBack();
                this.$message({
                  showClose: true,
                  message: this.$t('message.success'),
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            });
          })
          .catch(() => {
            loading.endLoading();
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },

      // 返回
      goBack() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              title: this.$t('currenciesAndCalendar.addCurrencies.addCurrencies'),
            },
          },
          toPath: {
            path: '/credit/equipmentMortgageList',
            name: 'equipmentMortgageList',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .deliveryOrderTop {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 26px 10px 11px 10px;
  }
</style>
